import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";

const UpdateInstituteProfile = () => {
  const sessionId = localStorage.getItem("sessionId");
  const userUID = localStorage.getItem("userUID");

  const [displays, setDisplays] = useState(false);
  // ...............................PROFILE Start.......................................
  const [instituteEmail, setInstituteEmail] = useState("");
  const [instituteContact, setInstituteContact] = useState("");
  const [cityValue, setCitValue] = useState("");
  const [website, setWebiste] = useState("");
  const [tagline, setTagline] = useState("");
  const [startDate, setStartDate] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageview, setProfileImageview] = useState("");
  const [about, setAbout] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showWarningToast, setShowWarningToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [genderModal, setGenderModal] = useState(true);

  // ...............................City DDL.......................................
  const dispatch = useDispatch();
  const [cityId, setcityId] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      setcityId(selectedOption.value);
      // dispatch(selectCity(selectedOption.value));
    }
  };
  // console.log("selectedcityId", selectedcityId);

  // ...............................City DDL.......................................

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setProfileImageview(URL.createObjectURL(selectedFile));
  };

  const InstituteUpdate = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);
      if (
        instituteContact &&
        instituteEmail &&
        cityId &&
        website &&
        about &&
        tagline &&
        description &&
        address &&
        startDate &&
        profileImage !== ""
      ) {
        const formData = new FormData();
        formData.append("emailId", instituteEmail);
        formData.append("contactId", instituteContact);
        formData.append("CityId", cityId);
        formData.append("WebsiteId", website);
        formData.append("About", about);
        formData.append("tagline", tagline);
        formData.append("AddressId", address);
        formData.append( "Dob", startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD") );
        formData.append("ProfileImage", profileImage);
        formData.append("sessionId", sessionId);

        const res = await axios.post( "/Account/UpdateInstituteProfile", formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setToastMessage(res.data.message);
        toast.success(res.data.message);
        setShowToast(true);
        setAddress("");
        setAbout("");
        setCitValue("");
        setDescription("");
        setProfileData(null);
        setProfileImage(null);
        setInstituteEmail("");
        setInstituteContact("");
        setWebiste("");
        setTagline("");
        setProfileImageview(null);
        setDisplays(false);
      } else {
        toast.error("please enter required fields!");
        // { position: "top-center" }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
        toast.warning(error.response.data.message);
      } else {
        setErrorToastMessage(
          error.response?.data?.message || "An error occurred"
        );
        setShowErrorToast(true);
        toast.error(error.response?.data?.message || "An error occurred");
      }

      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
        toast.warning(error.response.data.message);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
        // toast.error(error.response.data.message)
      }
    }
  };

  // ...............................PROFILE End.......................................

  // ...............................Get PROFILE Start.......................................
  const [profileData, setProfileData] = useState("");
  const GetProfile = async () => {
    try {
      const res = await axios.get(`/Institute/GetProfile?UID=${userUID}`);
      setProfileData(res.data.responseData);
      console.log("=====>", res.data.responseData);
      const userData = res.data.responseData;
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    GetProfile();
  }, []);

  useEffect(() => {
    if (profileData) {
      setInstituteEmail(profileData?.email);
      setInstituteContact(profileData?.contactNo); 
      setWebiste(profileData?.website);
      setTagline(profileData?.tagline);
      setStartDate(profileData?.startedDate);
      setProfileImageview(profileData?.logoImage);
      setAbout(profileData?.about);
      setDescription(profileData?.description);
      setcityId(profileData?.cityId);
      setAddress("");
      localStorage.setItem("name", profileData.name);
      localStorage.setItem("startedDate", profileData.startedDate);
      localStorage.setItem("compType", profileData.compType);
      localStorage.setItem("cityName", profileData.cityName);
      localStorage.setItem("email", profileData.email);
      localStorage.setItem("profilPic", profileData.logoImage);
    }
  }, [profileData]);

  // ...............................Get PROFILE End.......................................
  return (
    <>
      <h6>Profile Setting</h6>
      <div className="profile-setting-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="instituteEmail">Institute Email</label>
            <input
              type="text"
              id="instituteEmail"
              className="form-control Dark-Input-from-group"
              placeholder="Email"
              required
              onChange={(e) => setInstituteEmail(e.target.value)}
              value={instituteEmail}
              invalid={displays && instituteEmail === ""}
            />
            {displays && !instituteEmail ? (
              <span className="error_msg_lbl text-red">Enter Email </span>
            ) : null}
          </div>

          <div className="form-group">
            <label htmlFor="contact">Contact No</label>
            <input
              type="text"
              id="contact"
              className="form-control Dark-Input-from-group"
              placeholder="Contact No"
              required
              onChange={(e) => setInstituteContact(e.target.value)}
              value={instituteContact}
              invalid={displays && instituteContact === ""}
            />
            {displays && !instituteContact ? (
              <span className="error_msg_lbl text-red">Enter No </span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="city">City</label>
            <ReactSelect
              options={cityList}
              onChange={handleCitySelect}
              value={
                cityList.find((option) => option.value === cityId) ||
                null
              }
              placeholder="Select city"
              styles={customStyles}
              classNamePrefix="react-select"
              className="form-control"
            />
            {displays && !cityId ? (
              <span className="error_msg_lbl text-red">Enter City </span>
            ) : null}
          </div>
          <div className="form-group">
            <label htmlFor="website">Website</label>
            <input
              type="text"
              id="website"
              className="form-control Dark-Input-from-group"
              placeholder="Website"
              required
              onChange={(e) => setWebiste(e.target.value)}
              value={website}
              invalid={displays && website === ""}
            />
            {displays && !website ? (
              <span className="error_msg_lbl text-red">Enter Website </span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="tagline">Tagline</label>
            <input
              type="text"
              id="tagline"
              className="form-control Dark-Input-from-group"
              placeholder="Tagline"
              required
              onChange={(e) => setTagline(e.target.value)}
              value={tagline}
              invalid={displays && tagline === ""}
            />
            {displays && !tagline ? (
              <span className="error_msg_lbl text-red">Enter Tag </span>
            ) : null}
          </div>
          <div className="form-group">
            <label htmlFor="IncorpDate">Start Date</label>
            <Flatpickr
              className="form-control Dark-Input-from-group"
              required
              onChange={(date) => setStartDate(date[0])}
              value={startDate}
              invalid={displays && startDate === ""}
            />
            {displays && !startDate ? (
              <span className="error_msg_lbl text-red">Enter Date </span>
            ) : null}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Logo Image</label> 
            <input
              type="file"
              className="form-control Dark-Input-from-group"
              required 
              onChange={(e) => {
                handleProfileImageChange(e);
              }} 
              invalid={displays && profileImage === ""}
            />
            {displays && !profileImage ? (
              <span className="error_msg_lbl text-red">Upload Image </span>
            ) : null} 
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="About">About</label> 
          <textarea
            className="form-control Dark-Input-from-group"
            placeholder="About"
            required
            onChange={(e) => setAbout(e.target.value)}
            value={about}
            invalid={displays && about === ""}
          ></textarea>
          {displays && !about ? (
            <span className="error_msg_lbl text-red">Write About</span>
          ) : null}
        </div>
        <div className="form-group">
          <label htmlFor="Description">Description</label>
          <textarea
            className="form-control Dark-Input-from-group"
            placeholder="Description"
            required
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            invalid={displays && description === ""}
          ></textarea>
          {displays && !description ? (
            <span className="error_msg_lbl text-red">Write Description </span>
          ) : null}
        </div>
        <div className="form-group">
          <label htmlFor="Address">Address</label>
          <textarea
            className="form-control Dark-Input-from-group"
            placeholder="Address"
            required
            onChange={(e) => setAddress(e.target.value)}
            value={address}
            invalid={displays && address === ""}
          ></textarea>
          {displays && !address ? (
            <span className="error_msg_lbl text-red">Enter Address </span>
          ) : null}
        </div>

        <button className="btn btn-primary" onClick={(e) => InstituteUpdate(e)}>
          Update
        </button>
      </div>
    </>
  );
};

export default UpdateInstituteProfile;
